/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Gettingstarted_Item31Inputs */

const he_help_gettingstarted_item31 = /** @type {(inputs: Help_Gettingstarted_Item31Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`צרו את הפוסט הראשון שלכם`)
};

const en_help_gettingstarted_item31 = /** @type {(inputs: Help_Gettingstarted_Item31Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create your first post`)
};

/**
* | output |
* | --- |
* | "Create your first post" |
*
* @param {Help_Gettingstarted_Item31Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const help_gettingstarted_item31 = /** @type {((inputs?: Help_Gettingstarted_Item31Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Gettingstarted_Item31Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_help_gettingstarted_item31(inputs)
	return en_help_gettingstarted_item31(inputs)
});
export { help_gettingstarted_item31 as "help_gettingStarted_item3" }